<template>
  <div id="left-menu" v-if="!loading">
    <div class="content">
      <UserProgress :TASKS_BY_DAY="phasesByDay">
      </UserProgress>
      <UserTasks :tasks="currentPhaseTasks" :phase="phase">
      </UserTasks>
      <div id="next-day">
        <b-button 
          variant="user-primary"
          :class="`${(phase === phases[0]) ? 'custom-button-disabled' : 'custom-button'}`"
          @click="PreviousPhase()"
          :disabled="phase === phases[0]"
        >
          <i class="fa fa-chevron-left"/>
        </b-button>
        <b-button 
          variant="user-primary"
          :class="`${(!isPhaseComplete(phase)) || (phase === phases[phases.length - 1]) ? 'custom-button-disabled' : 'custom-button'}`"
          @click="NextPhase()"
          :disabled="(!isPhaseComplete(phase)) || (phase === phases[phases.length - 1])"
        >
          <i class="fa fa-chevron-right"/>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Progress from '../../components/Parks/Progress.vue';
import Tasks from '../../components/Parks/Tasks.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    UserProgress: Progress,
    UserTasks: Tasks,
  },
  data: () => ({
    tasks: [],
    phase: 0,
    loading: false,
    pcs: {},
    phasesByDay: new Map(),
  }),
  computed: {
    ...mapState({
    completedEvents: state => state.events.completedEvents,
    currentPhaseTasks: function() {
      return this.filterRoleTasks.filter(task => task.phase === this.phase).sort((a, b) => a.order - b.order)
    },
    emails: state => state.email.emailActions,
    phases: state => state.events.phases,
    }),
    filterRoleTasks: function() {
      if (this.pcs.role_based) {
        return this.tasks.filter(task => {
          let actions = JSON.parse(task.action)
          if (actions.length > 1){ // Multiple roles in one event
            return actions.some(action => action.role === this.role.role_id)
          }
          else {
            if (actions[0] && actions[0].role && this.role.role_id){
              return (actions[0].role === this.role.role_id)
            } 
            else {
              return true;
            }
          }
        })
      }
      else {
        return this.tasks
      }
    },
    ...mapGetters('group', ['role']),
    ...mapGetters('auth', ['user', 'classId']),
    ...mapGetters('events', ['currentPhase', 'taskCompletion', 'isPhaseComplete', 'phases']),
  },
  watch: {
    taskCompletion: {
      handler: function() {
        this.refreshTasks()
      },
      deep: true
    },
    emails: function (){
      this.refreshTasks()
    },
    phases: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.calculatePhasesByDay()
      }
    },
  },
  created() {
    // pull in dashboard html
    this.loading = true
    axios.post('/api/load_pcs_info', {
      params: {
        pcsId: localStorage.getItem('pcs'),
      }
    })
    .then(response => {
      this.pcs = response.data
      this.refreshTasks()
    })
  },

  methods: {
    refreshTasks: function() {
      // get tasks
      axios.post('/api/pcs/tasks', {
        params: {
          pcs: localStorage.getItem('pcs'),
          class_id: this.classId,
        }
      })
      .then(response => {
        this.tasks = response.data
        this.phase = this.currentPhase
        this.calculatePhasesByDay()
        this.loading = false
      })
    },
    PreviousPhase: function() {
      if (this.phase !== 0) {
        this.phase -= 1
      }
    },

    NextPhase: function() {
      if (this.phase !== this.phases.length - 1) {
        this.phase += 1
      }
    },

    calculatePhasesByDay: function() {
      //sort by sort order first 
      let tasks =  this.filterRoleTasks.sort((a, b) => a.order - b.order)
      let map = new Map()
      this.phases.forEach(phase => {
        map.set(phase,[]);
      })
      tasks.forEach(task => {
        map.get(task.phase).push(task)
      })
      this.phasesByDay = map
    },

    getCompleted(phase) {
      let currPhase = this.taskCompletion.get(phase)
      if (currPhase) {
        return currPhase.completed.length
      }
      else {
        return 0
      }
    },

    getTotal(phase) {
      let currPhase = this.taskCompletion.get(phase)
      if (currPhase) {
        return currPhase.total.length
      }
      else {
        return 0
      }
    },
  },
}

</script>

<style scoped>
#left-menu {
    background-color: white;
    border-right: .5px solid lightgrey;
    overflow-y: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    height: 100%
}
#left-menu::-webkit-scrollbar{
  display:none;
}

.content {
  padding: 15px;
}

.custom-button{
  /* background-color: rgb(17, 145, 134); */
  cursor: pointer;
  padding-left: 2em;
  padding-right: 2em;  
}
/* .custom-button:hover {
    background-color: rgb(60, 155, 147);
} */
.custom-button-disabled {
  padding-left: 2em;
  padding-right: 2em;     
}

#next-day {
  display: flex;
  justify-content: center;
  gap: 5px;
}

</style>